module.exports = __webpack_public_path__ + "img/farzana-christopher-142.459d515a.jpg";